import type { Authenticator } from './types';

let authenticator: Authenticator | undefined;

type GetAuthenticator = () => Authenticator;
export const getAuthenticator: GetAuthenticator = () => {
  if (authenticator == null) {
    throw new Error('Authenticator has not been set!');
  }

  return authenticator;
};

type SetAuthenticator = (newAuthenticator: Authenticator) => void;
export const setAuthenticator: SetAuthenticator = (newAuthenticator) => {
  authenticator = newAuthenticator;
};

/**
 * Returns whether the signed-in account is a guest in the Microsoft tenant.
 */
export const isCurrentAccountMicrosoftGuest = (): boolean => authenticator?.isCurrentAccountMicrosoftGuest?.() ?? false;

export interface AcquireTokenOptions {
  readonly scopes: string[];
  readonly claims?: string;
  readonly tenantId?: string;
  readonly silent?: boolean;
  readonly forceRefresh?: boolean;
}

export type AcquireToken = (options: AcquireTokenOptions) => Promise<string>;
export const acquireTokenWithoutTelemetry: AcquireToken = async ({ scopes, claims, tenantId, silent, forceRefresh }) =>
  getAuthenticator().acquireToken(scopes, claims, tenantId, silent, forceRefresh);

export const acquireToken: AcquireToken = async ({ scopes, claims, tenantId, silent, forceRefresh }) =>
  await acquireTokenWithoutTelemetry({ scopes, claims, tenantId, silent, forceRefresh });

type AcquireTokenRedirect = (scopes: string[], claims?: string) => void;
export const acquireTokenRedirect: AcquireTokenRedirect = (scopes, claims) => {
  getAuthenticator().acquireTokenRedirect(scopes, claims);
};

type Logout = () => void;
export const logout: Logout = () => {
  const authInstance = getAuthenticator();

  if (authInstance.logout) {
    authInstance.logout();
  }
};
